<!-- Affichage de la liste des attribut-->

<div class="scroll-container">
    <div class="attributes-container">
        @for (attributeDefinition of filteredAttributesDefinitions; track attributeDefinition.id) {
            @if (attributeDefinition.propertyCode === BOX_ID) {
                <div class="attributes-value small">
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>{{ attributeDefinition.mandatory === true ? attributeDefinition.header + '*' : attributeDefinition.header }}</mat-label>
                            <mat-select [disabled]="readonly" [ngClass]="{ readonly: readonly }" [value]="folder.boxId" (selectionChange)="onUpdateBoxAttribute($event.value)">
                                @for (boxGroup of boxGroupInfo; track boxGroup.id) {
                                    <mat-optgroup [label]="boxGroup.name">
                                        @for (box of boxGroup.boxes; track box.id) {
                                            <mat-option [value]="box.id">{{ box.name }}</mat-option>
                                        }
                                    </mat-optgroup>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            } @else if (attributeDefinition.propertyCode === CREATION_DATE || attributeDefinition.propertyCode === UPDATE_DATE) {
                <app-attribute
                    [readonly]="true"
                    class="attributes-value small"
                    [attributeDefinition]="attributeDefinition"
                    [value]="folder | avmAttributeFieldPipe: attributeDefinition"
                    (valueUpdated)="onUpdateAttribute(attributeDefinition.propertyCode, $event)"></app-attribute>
            } @else if (attributeDefinition.propertyCode === ID) {
                <app-attribute
                    [readonly]="true"
                    class="attributes-value small"
                    [attributeDefinition]="attributeDefinition"
                    [value]="folder | avmAttributeFieldPipe: attributeDefinition"
                    (valueUpdated)="onUpdateAttribute(attributeDefinition.propertyCode, $event)"></app-attribute>
            } @else if (
                attributeDefinition.propertyCode !== BOX_ID &&
                attributeDefinition.propertyCode !== WORKFLOW_ID &&
                attributeDefinition.propertyCode !== CREATION_DATE &&
                attributeDefinition.propertyCode !== UPDATE_DATE &&
                attributeDefinition.propertyCode !== ID
            ) {
                <app-attribute
                    [readonly]="readonly"
                    class="attributes-value small"
                    [attributeDefinition]="attributeDefinition"
                    [value]="folder | avmAttributeFieldPipe: attributeDefinition"
                    (valueUpdated)="onUpdateAttribute(attributeDefinition.propertyCode, $event)"></app-attribute>
            }
        }
        <ngx-spinner name="attributes-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </div>
</div>
